import React from 'react'
import dayjs from 'dayjs'

const MAX_DAYS_DIFF = 90

const isDisabled = (from: Date, to: Date) => {
    const fromDate = dayjs(from)
    const toDate = dayjs(to)

    const diff = toDate.diff(fromDate, 'day')

    return diff > MAX_DAYS_DIFF
}

export const useDownloadReportDisabled = ({ from, to }: { from: Date; to: Date }) => {
    const [isDisabledReportDownload, setIsDisabledReportDownload] = React.useState(() =>
        isDisabled(from, to)
    )

    React.useEffect(() => {
        setIsDisabledReportDownload(isDisabled(from, to))
    }, [from, to])

    return {
        isDisabledReportDownload,
    }
}
